import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=2f4b6f1f&scoped=true"
import script from "./privacy_policy.vue?vue&type=script&lang=js"
export * from "./privacy_policy.vue?vue&type=script&lang=js"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=2f4b6f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b6f1f",
  null
  
)

export default component.exports